import http from '../core/http-common'
import { ITransactionResponse } from '../types/MainType'
import {
  IFloorReservationList,
  IMostUsedReservationResponse,
  IReservationList,
  IReservationListRequest,
  ISaveReservation,
  ISaveReservationResponse,
} from '../types/Reservation'

class ReservationService {
  getReservationList(request: IReservationListRequest) {
    return http.post<IReservationList[]>('/Reservation/GetReservationList', request)
  }

  getFloorReservationList(request: IReservationListRequest) {
    return http.post<IFloorReservationList>('/FloorReservation/GetReservationList', request)
  }

  deleteReservation(request: any) {
    return http.post<ITransactionResponse>('/Reservation/DeleteReservation', request)
  }

  deleteFloorReservation(request: any) {
    return http.post<ITransactionResponse>('/FloorReservation/DeleteReservation', request)
  }

  getReservation(id: number) {
    return http.get<IReservationList>(`/Reservation/GetReservation?id=${id}`)
  }

  getMostUsedReservation(date: string) {
    let url = `/Reservation/GetMostUsedReservation?&occupancyDate=${date}`
    return http.get<IMostUsedReservationResponse>(url)
  }

  saveReservation(request: ISaveReservation) {
    return http.post<ISaveReservationResponse>('/Reservation/SaveReservation', request)
  }

  saveMultiReservation(request: ISaveReservation) {
    return http.post<ISaveReservationResponse>('/Reservation/SaveMultiReservation', request)
  }

  saveFloorReservation(request: ISaveReservation) {
    return http.post<ISaveReservationResponse>('/FloorReservation/SaveReservation', request)
  }
}

export default new ReservationService()
